export enum EMapItemZIndex {
  INFRASTRUCTURE = 1,
  BALLOON_DEFAULT = 5,
  BALLOON_ACTIVE = 10,
}
